/* eslint-disable no-nested-ternary */
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

const Buttons = (props: any) => {
  const { id, videoId, onPlayVideoBtnClick, isMobile } = props;
  const { locale, asPath }: any = useRouter();
  const [switchUrl, setSwitchUrl] = useState(false);
  const [prevRoute, setPrevRoute] = useState('');

  useEffect(() => {
    const switchLocale = JSON.parse(sessionStorage.getItem('switchLocale'));
    const currentUrl = {
      path: asPath,
      locale,
      domain: process.env.NEXT_PUBLIC_SITE_URL_ORIGIN,
      switchLocale,
    };
    const preRoute = JSON.parse(sessionStorage.getItem('preRoute'));
    const getPreRoute = JSON.parse(sessionStorage.getItem('prevRoute'));
    const getUpdateRoute = JSON.parse(sessionStorage.getItem('updateRou'));
    if (
      getPreRoute &&
      getPreRoute.locale === locale &&
      (preRoute !== getUpdateRoute || (!preRoute && !getUpdateRoute))
    ) {
      setPrevRoute(getPreRoute.path);
      setSwitchUrl(false);
      sessionStorage.setItem('preRoute', JSON.stringify(currentUrl));
      sessionStorage.setItem('switchLocale', JSON.stringify(locale));
    } else {
      setSwitchUrl(true);
      if (preRoute && locale !== switchLocale) {
        const { switchLocale: switchRou, domain, path, locale: lng } = preRoute;
        const url =
          preRoute && switchRou
            ? `${domain}/${switchRou}${path}`
            : `${domain}/${lng}${path}`;
        setPrevRoute(url);
        sessionStorage.setItem('updateRou', JSON.stringify(currentUrl));
        sessionStorage.setItem('prevRoute', null);
      } else if (getUpdateRoute && preRoute && preRoute !== getUpdateRoute) {
        const { domain, path, locale: lng } = getUpdateRoute;
        const url =
          getUpdateRoute && getUpdateRoute.locale && `${domain}/${lng}${path}`;
        setPrevRoute(url);
        sessionStorage.setItem('preRoute', JSON.stringify(currentUrl));
        sessionStorage.setItem('prevRoute', null);
      } else if (!preRoute && !getUpdateRoute && !getPreRoute) {
        setPrevRoute(
          `${process.env.NEXT_PUBLIC_SITE_URL_ORIGIN}/${locale}${asPath}`
        );
        sessionStorage.setItem('preRoute', JSON.stringify(currentUrl));
        sessionStorage.setItem('switchLocale', JSON.stringify(locale));
      } else {
        setPrevRoute(
          `${process.env.NEXT_PUBLIC_SITE_URL_ORIGIN}/${locale}${asPath}`
        );
      }
    }
  }, []);

  return (
    <div className="sv-image-gallery-btns">
      {!switchUrl ? (
        <Link href={prevRoute} passHref>
          <button className="btn sv-back-btn">
            <span className="sv-btn-icon">
              <img src="/images/sv-back-btn-arrow.svg" alt="Back Arrow" />
            </span>
            <FormattedMessage id="back" />
          </button>
        </Link>
      ) : (
        <button
          className="btn sv-back-btn"
          // eslint-disable-next-line no-return-assign
          onClick={() => (window.location.href = prevRoute)}
        >
          <span className="sv-btn-icon">
            <img src="/images/sv-back-btn-arrow.svg" alt="Back Arrow" />
          </span>
          <FormattedMessage id="back" />
        </button>
      )}

      <button
        className="btn sv-play-video-btn"
        aria-label={locale === 'en' ? 'Play Video' : 'Voir vidéo'}
        data-bs-toggle="modal"
        data-bs-target={`#${videoId || id}`}
        onClick={onPlayVideoBtnClick}
      >
        <span className="sv-btn-icon">
          <img
            src="/images/sv-play-video-white-icon.svg"
            alt={locale === 'en' ? 'Play Video' : 'Voir vidéo'}
          />
        </span>
        <FormattedMessage id="playVideo" />
      </button>

      <button
        className="btn sv-back-btn btn-position"
        aria-label={locale === 'en' ? '10+ Photos' : 'Photos 10+'}
        data-bs-toggle="modal"
        data-bs-target={`#${id}`}
      >
        <span className="sv-btn-icon">
          <img src="/images/sv-images-icon.svg" alt="Images" />
        </span>
        {isMobile ? '10+' : locale === 'en' ? '10+ Photos' : 'Photos 10+'}
      </button>
    </div>
  );
};

export default Buttons;
